/**
 * Career plan API
 * Career plan API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CdpPackageItemStatusModel = 'ACTIVE' | 'DISABLED';

export const CdpPackageItemStatusModel = {
    Active: 'ACTIVE' as CdpPackageItemStatusModel,
    Disabled: 'DISABLED' as CdpPackageItemStatusModel
};

